import React from 'react'
import { Style } from './style'

type LoadingProps = {
  size?: number
}

const Loading = ({ size = 80 }: LoadingProps) => {
  return (
    <Style $size={size}>
      <div className='block' />
      <div className='lds-roller'>
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </Style>
  )
}

export default Loading
